import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  FaShoppingCart,
  FaFileAlt,
  FaHeadset,
  FaUserCircle,
} from "react-icons/fa";

const BRAND_GRADIENT = "linear-gradient(135deg, #5f2eea, #0a84ff)";

/* ================= WRAPPER ================= */

const Wrapper = styled.div`
  min-height: 100vh;
  padding: 40px 20px;
  font-family: "Poppins", sans-serif;
  color: #fff;
`;

/* ================= HEADER ================= */

const Header = styled.div`
  margin-bottom: 40px;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: ${BRAND_GRADIENT};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Subtitle = styled.p`
  color: #cbd5e1;
  margin-top: 8px;
`;

/* ================= GRID ================= */

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
`;

/* ================= CARD ================= */

const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  border-radius: 18px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
`;

const IconWrapper = styled.div`
  font-size: 26px;
  margin-bottom: 16px;
`;

const CardTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 6px;
`;

const Value = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
`;

/* ================= SECTION ================= */

const Section = styled.div`
  margin-top: 50px;
`;

const SectionTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ActionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
`;

const ActionCard = styled(motion.div)`
  padding: 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  cursor: pointer;
  text-align: center;
`;

const ActionText = styled.p`
  margin-top: 10px;
  font-weight: 600;
`;

/* ================= COMPONENT ================= */

export default function CustomerDashboard() {
  return (
    <Wrapper>
      <Header>
        <Title>Customer Dashboard</Title>
        <Subtitle>Manage your services and support from here.</Subtitle>
      </Header>

      <Grid>
        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaFileAlt />
          </IconWrapper>
          <CardTitle>Active Proposals</CardTitle>
          <Value>2</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaShoppingCart />
          </IconWrapper>
          <CardTitle>Purchased Services</CardTitle>
          <Value>1</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaHeadset />
          </IconWrapper>
          <CardTitle>Open Support Tickets</CardTitle>
          <Value>0</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaUserCircle />
          </IconWrapper>
          <CardTitle>Profile Status</CardTitle>
          <Value>Verified</Value>
        </Card>
      </Grid>

      <Section>
        <SectionTitle>Quick Actions</SectionTitle>

        <ActionGrid>
          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaFileAlt size={24} />
            <ActionText>Request Proposal</ActionText>
          </ActionCard>

          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaHeadset size={24} />
            <ActionText>Raise Support Ticket</ActionText>
          </ActionCard>

          <ActionCard whileHover={{ scale: 1.05 }}>
            <FaUserCircle size={24} />
            <ActionText>Edit Profile</ActionText>
          </ActionCard>
        </ActionGrid>
      </Section>
    </Wrapper>
  );
}
